<template>
  <div
    class="base-checkbox"
    :class="{ 'disabled': disabled }"
    @click="!disabled && toggle()"
  >
    <font-awesome-icon
      :icon="indeterminate ? ['fas', 'square-minus'] : (modelValue ? ['fas', 'square-check'] : ['fal', 'square'])"
      :class="['checkbox-icon', { 'disabled': disabled }]"
      size="lg"
    />
    <span v-if="label" :class="['checkbox-label', { 'disabled': disabled }]">{{ label }}</span>
    <input
      :id="id"
      type="checkbox"
      :checked="modelValue"
      :indeterminate="indeterminate"
      :disabled="disabled"
      class="hidden-checkbox"
      @change="handleChange"
    >
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
  id: {
    type: [String, Number],
    default: () => `checkbox-${Math.random().toString(36).slice(2, 11)}`,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  indeterminate: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const isChecked = ref(props.modelValue);

const toggle = () => {
  if (!props.disabled) {
    isChecked.value = !props.modelValue;
    emit('update:modelValue', isChecked.value);
  }
};

const handleChange = (event) => {
  if (!props.disabled) {
    isChecked.value = event.target.checked;
    emit('update:modelValue', isChecked.value);
  }
};
</script>

<style scoped>
.base-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 1rem;
}

.base-checkbox.disabled {
  cursor: not-allowed;
}

.checkbox-icon {
  color: var(--color-primary);
}

.checkbox-icon.disabled {
  color: var(--color-text-muted, #ccc);
}

.checkbox-label {
  margin-left: 0.5rem;
}

.checkbox-label.disabled {
  color: var(--color-text-muted, #999);
}

.hidden-checkbox {
  display: none;
}
</style>
